module.exports = __webpack_public_path__ + "static/logo-black-new-70a940b64802bf859c8c66c4acd208ec.svg";